var AbstractFavouritesEditView = require("./AbstractFavouritesEditView");
var Utils = require("common/Utils");

/**
 *
 * @class
 * @extends AbstractFavouritesEditView
 */
function AddFavouritesView() {
    AbstractFavouritesEditView.call(this);

    var self = this;
    var $addButton = $('<a href="#" data-role="button" data-icon="mobile-confirm" data-iconpos="notext" data-inline="true">');
    /**
     * @override
     * @inheritDoc
     */
    this.getHashName = function() {
        return "AddFavourites";
    };

    $addButton.on("click", function() {
        // Figure out what has been selected
        var resources = [];
        self.getContent().find(".favSelectionMarker").closest("li").each(function() {
            resources.push($(this).attr("data-resource-id"));
        });
        self.publishEvent("FavouritesController", "add-favourites", {resources : resources});
    });

    var super_getHeaderConfiguration = this.getHeaderConfiguration;
    /**
     * @override
     * @inheritDoc
     */
    this.getHeaderConfiguration = function() {
        return $.extend(super_getHeaderConfiguration(), {
            title : $.t("common::favourites.add.description"),
            i18n : "common::favourites.add.description",
            rightButtons : [$addButton],
            additionalClasses : "add"
        });
    };

    /**
     * @override
     * @inheritDoc
     */
    this.onResourceItemClick = function(e) {
        e.preventDefault();
        e.stopPropagation();

        var $li = $(e.target).closest("li");
        $li.toggleClass("favSelectionMarker add");
        Utils.setElementEnabled($addButton, self.getContent().find(".favSelectionMarker").size() > 0);
    };

    var super_show = this.show;
    /**
     * @override
     * @inheritDoc
     */
    this.show = function() {
        Utils.setElementEnabled($addButton, false);

        super_show.call(this);
    };
}

Utils.inherits(AddFavouritesView, AbstractFavouritesEditView);

module.exports = AddFavouritesView;